import React from 'react';
import { StarIcon, UsersIcon, FileTextIcon, HeartIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="py-12 bg-white border-b border-gray-100" data-id="element-248">
      <div className="max-w-5xl mx-auto px-4" data-id="element-249">
        {/* Buyer Counter Banner */}
        <div className="bg-green-50 border border-green-100 rounded-2xl p-4 mb-10 text-center max-w-2xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 shadow-sm" data-id="element-250">
          <div className="flex -space-x-2" data-id="element-251">
            <img className="w-8 h-8 rounded-full border-2 border-white object-cover" src="https://i.pravatar.cc/100?img=1" alt="User" data-id="element-252" />
            <img className="w-8 h-8 rounded-full border-2 border-white object-cover" src="https://i.pravatar.cc/100?img=5" alt="User" data-id="element-253" />
            <img className="w-8 h-8 rounded-full border-2 border-white object-cover" src="https://i.pravatar.cc/100?img=8" alt="User" data-id="element-254" />
            <div className="w-8 h-8 rounded-full border-2 border-white bg-green-200 flex items-center justify-center text-xs font-bold text-green-800" data-id="element-255">
              +
            </div>
          </div>
          <p className="text-gray-800 font-medium" data-id="element-256">
            Gi&agrave; scelto da{' '}
            <span className="font-bold text-green-700" data-id="element-257">2.847+ insegnanti</span>{' '}
            in tutta Italia
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-258">
          <div className="flex flex-col items-center p-4 rounded-2xl bg-blue-50" data-id="element-259">
            <FileTextIcon className="w-8 h-8 text-blue-600 mb-3" data-id="element-260" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-261">300+</h3>
            <p className="text-sm text-gray-600 font-medium" data-id="element-262">
              Risorse digitali
            </p>
          </div>
          <div className="flex flex-col items-center p-4 rounded-2xl bg-orange-50" data-id="element-263">
            <UsersIcon className="w-8 h-8 text-orange-500 mb-3" data-id="element-264" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-265">2.8k+</h3>
            <p className="text-sm text-gray-600 font-medium" data-id="element-266">
              Insegnanti attivi
            </p>
          </div>
          <div className="flex flex-col items-center p-4 rounded-2xl bg-green-50" data-id="element-267">
            <StarIcon className="w-8 h-8 text-green-500 mb-3 fill-current" data-id="element-268" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-269">4.9/5</h3>
            <p className="text-sm text-gray-600 font-medium" data-id="element-270">
              Valutazione media
            </p>
          </div>
          <div className="flex flex-col items-center p-4 rounded-2xl bg-red-50" data-id="element-271">
            <HeartIcon className="w-8 h-8 text-red-500 mb-3 fill-current" data-id="element-272" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-273">100%</h3>
            <p className="text-sm text-gray-600 font-medium" data-id="element-274">Soddisfazione</p>
          </div>
        </div>
      </div>
    </section>;
}